"use strict";
// tslint:disable:max-line-length
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var portalBase_1 = require("./portalBase");
var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns response from POST to '/oauth/token', automatically sets the accesstoken on the  on success.
     * @async
     * @param { OauthTokenBody } OauthTokenBody
     * @returns { Promise<AttensiAPIResponse<OauthTokenData>> } OauthTokenData
     */
    Portal.prototype.postOauthToken = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postWithBody('/oauth/token', body)];
                    case 1:
                        response = _a.sent();
                        this.accessToken = response.data.access_token;
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Returns response from POST to '/oauth/revoke', and removes the accesstoken from the api instance
     * @async
     * @param { OauthTokenBody } OauthTokenBody
     * @returns {Promise<AttensiAPIResponse<OauthRevokeData>>} OauthRevokeData
     */
    Portal.prototype.postOauthRevoke = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var oauthRevokeBody, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!accessToken) {
                            accessToken = this.accessToken;
                            this.accessToken = null;
                        }
                        else {
                            if (accessToken === this.accessToken) {
                                this.accessToken = null;
                            }
                        }
                        if (!accessToken) {
                            throw Error('No access token to revoke');
                        }
                        oauthRevokeBody = {
                            token_type_hint: 'access_token',
                            token: accessToken
                        };
                        return [4 /*yield*/, this.postWithBody('/oauth/revoke', oauthRevokeBody)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Returns response from POST to '/signin'
     * @async
     * @param  { SigninBody } SigninBody
     * @returns { Promise<AttensiAPIResponse<SigninData>> } SigninData
     */
    Portal.prototype.postSignin = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postWithBody('/signin', body)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from POST to '/authorize/openid_connect'
     * @async
     * @param  { AuthorizeOpenidConnectBody } postAuthorizeOpenidConnect
     * @returns { Promise<AttensiAPIResponse<AuthorizeOpenidConnectData>> } AuthorizeOpenidConnectBody
     * @todo How to write tests?
     */
    Portal.prototype.postAuthorizeOpenidConnect = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postWithBody('/authorize/openid_connect', body)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from POST to /authorize/azure_ad_oauth2'
     * @async
     * @param  { AuthorizeAzureAdOAuth2Body } AuthorizeAzureAdOAuth2Body
     * @returns { Promise<AttensiAPIResponse<AuthorizeAzureAdOAuth2Data>> } AuthorizeAzureAdOAuth2Data
     * @todo How to write tests?
     */
    Portal.prototype.postAuthorizeAzureAdOAuth2 = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postWithBody('/authorize/azure_ad_oauth2', body)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from POST to /authorize/jwt'
     * @async
     * @param  { AuthorizeJwtBody } AuthorizeJwtBody
     * @returns { Promise<AttensiAPIResponse<AuthorizeJwtData>> } AuthorizeJwtData
     * @todo How to write tests?
     */
    Portal.prototype.postAuthorizeJwt = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postWithBody('/authorize/jwt', body)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from POST to '/users/register/phone'
     * @async
     * @param  { UserRegisterPhoneBody } UserRegisterPhoneBody
     * @returns { Promise<AttensiAPIResponse<UserRegisterData>> } UserRegisterData
     */
    Portal.prototype.postUsersRegisterPhone = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postWithBody('/users/register/phone', body)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from POST to '/users/register/email'
     * @async
     * @param  { UserRegisterEmailBody } UserRegisterEmailBody
     * @returns { Promise<AttensiAPIResponse<UserRegisterData>> } UserRegisterPhoneData
     */
    Portal.prototype.postUsersRegisterEmail = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postWithBody('/users/register/email', body)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from POST to '/users/confirm/phone'
     * @async
     * @param  { UserConfirmPhoneBody } UserConfirmPhoneBody
     * @returns { Promise<AttensiAPIResponse<UserConfirmData>> } UserConfirmData
     * @todo How to write tests?
     */
    Portal.prototype.postUsersConfirmPhone = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postWithBody('/users/confirm/phone', body)];
                    case 1:
                        response = _a.sent();
                        this.accessToken = response.data.access_token;
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Returns response from POST to '/users/confirm/email'
     * @async
     * @param  { UserConfirmPhoneBody } UserConfirmPhoneBody
     * @returns { Promise<AttensiAPIResponse<UserConfirmData>> } UserConfirmData
     */
    Portal.prototype.postUsersConfirmEmail = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postWithBody('/users/confirm/email', body)];
                    case 1:
                        response = _a.sent();
                        this.accessToken = response.data.access_token;
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/'
     * @async
     * @returns { Promise<AttensiAPIResponse<MainData>> } MainData
     */
    Portal.prototype.getDefault = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/main'
     * @async
     * @returns { Promise<AttensiAPIResponse<MainData>> } MainData
     */
    Portal.prototype.getMain = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/main')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/home'
     * @async
     * @returns { Promise<AttensiAPIResponse<HomeData>> } HomeData
     */
    Portal.prototype.getHome = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/home')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/country_codes'
     * @async
     * @returns { Promise<AttensiAPIResponse<CountryCodeData[]>> } CountryCodeData[]
     */
    Portal.prototype.getCountryCodes = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/country_codes')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/users/me'
     * @async
     * @returns { Promise<AttensiAPIResponse<UsersMeData>> } UsersMeData
     */
    Portal.prototype.getUsersMe = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/users/me')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from PATCH to '/users/me'
     * @async
     * @param  { UsersMeData } patchedUser
     * @returns { Promise<AttensiAPIResponse<UsersMeData>> } UsersMeData
     * @todo Write tests
     */
    Portal.prototype.patchUsersMe = function (patchedUser) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchWithBody('/users/me', patchedUser)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/users/me/companies'
     * @async
     * @returns { Promise<AttensiAPIResponse<UsersMeCommpany[]>> } UsersMeCommpany[]
     */
    Portal.prototype.getUsersMeCompanies = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/users/me/companies')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to /users/me/prefs
     * @async
     * @returns { Promise<AttensiAPIResponse<JSON>> } JSON
     * @todo Write tests
     */
    Portal.prototype.getUsersMePrefs = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/users/me/prefs')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // TODO postUsersMePrefs fails. Returns 500 error;
    /**
     * Returns response from POST to /users/me/prefs
     * @async
     * @param  { JSON } prefs
     * @returns { Promise<AttensiAPIResponse<JSON>> } JSON
     * @todo Write tests
     */
    Portal.prototype.postUsersMePrefs = function (prefs) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postWithBody('/users/me/prefs', prefs)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/users'
     * @async
     * @returns { Promise<AttensiAPIResponse<UsersData[]>> } UsersData[]
     */
    Portal.prototype.getUsers = function (usersQuery) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        usersQuery = usersQuery ? usersQuery : {};
                        return [4 /*yield*/, this.getWithQuery('/users', usersQuery)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/users/{user_id}'
     * @async
     * @param  { number } userId
     * @returns { Promise<AttensiAPIResponse<UsersData>> } UsersData
     */
    Portal.prototype.getUser = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get("/users/" + userId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from PATCH to '/users/{user_id}'
     * @async
     * @param  { number } userId
     * @param  { UsersData } userData
     * @returns { Promise<AttensiAPIResponse<UsersData>> }
     * @todo Write tests
     */
    Portal.prototype.patchUsers = function (userId, userData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchWithBody('/users/' + userId, userData)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from POST to '/users/{user_id}/toggle/active'
     * @async
     * @param  { number } userId
     * @returns { Promise<AttensiAPIResponse<ToggleData>> } ToggleReportData
     */
    Portal.prototype.postUsersToggleActive = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postUsersToggle(userId, 'active')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from POST to '/users/{user_id}/toggle/anonymous'
     * @async
     * @param  { number } userId
     * @returns { Promise<AttensiAPIResponse<ToggleData>> } ToggleReportData
     */
    Portal.prototype.postUsersToggleAnonymous = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postUsersToggle(userId, 'anonymous')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from POST to '/users/{user_id}/toggle/report'
     * @async
     * @param  { number } userId
     * @returns { Promise<AttensiAPIResponse<ToggleData>> } ToggleReportData
     */
    Portal.prototype.postUsersToggleReport = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postUsersToggle(userId, 'report')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from POST to '/users/{user_id}/toggle/{toggleName}'
     * @async
     * @param  { number } userId
     * @param  { string } toggleName
     * @returns { Promise<AttensiAPIResponse<ToggleData>> } ToggleReportData
     */
    Portal.prototype.postUsersToggle = function (userId, toggleName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post("/users/" + userId + "/toggle/" + toggleName)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/users/me/products/status'
     * @async
     * @returns { Promise<AttensiAPIResponse<UsersMeProductsStatusData>> } UsersMeProductsStatusData
     */
    Portal.prototype.getUsersMeProductsStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/users/me/products/status')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/users/usernameavailable/{username}'
     * @async
     * @param  { string } username
     * @returns { Promise<AttensiAPIResponse<UsernameAvailableData>> } UsernameAvailableData
     */
    Portal.prototype.getUsersnameAvailable = function (username) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/users/usernameavailable/' + username)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/avatars'
     * @async
     * @returns { Promise<AttensiAPIResponse<AvatarsData>> } AvatarsData
     */
    Portal.prototype.getAvatars = function (avatarsQuery) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        avatarsQuery = avatarsQuery ? avatarsQuery : {};
                        return [4 /*yield*/, this.getWithQuery('/avatars', avatarsQuery)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // TODO FIGURE OUT WHY THIS DONT WORK
    /**
     * Returns response from GET to '/companies'
     * @async
     * @returns { Promise<AttensiAPIResponse<CompanyData[]>> } CompanyData[]
     * @todo Write tests
     */
    Portal.prototype.getCompanies = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/companies')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/companies/current'
     * @async
     * @returns { Promise<AttensiAPIResponse<CompanyData>> } CompanyData
     */
    Portal.prototype.getCompaniesCurrent = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/companies/current')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/companies/current/departments'
     * @async
     * @returns { Promise<AttensiAPIResponse<Department[]>> } Department[]
     * @todo Write tests
     */
    Portal.prototype.getCompaniesCurrentDepartments = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/companies/current/departments')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/companies/current/products'
     * @async
     * @returns { Promise<AttensiAPIResponse<ProductData[]>> } ProductData[]
     * @todo Write tests
     */
    Portal.prototype.getCompaniesCurrentProducts = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/companies/current/products')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/companies/{company_id}/products'
     * @async
     * @param  { number } companyId
     * @returns { Promise<AttensiAPIResponse<ProductData[]>> } ProductData[]
     * @todo Write tests
     */
    Portal.prototype.getCompaniesProducts = function (companyId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/companies/' + companyId + '/products')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/companies/code/{code}'
     * @async
     * @param  { string } code
     * @returns { Promise<AttensiAPIResponse<CompaniesCode>> } CompaniesCode
     * @todo Write tests
     */
    Portal.prototype.getCompaniesCode = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get("/companies/code?code=" + code)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/applications/current'
     * @async
     * @returns { Promise<AttensiAPIResponse<TODO>> } TODO
     * @todo Write tests
     */
    Portal.prototype.getApplicationsCurrent = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/applications/current')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/products/{product_id}'
     * @async
     * @param  { number } id
     * @returns { Promise<AttensiAPIResponse<ProductData>> } ProductData
     */
    Portal.prototype.getProducts = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/products/' + id)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/products/token/{token}'
     * @async
     * @param  { string } productToken
     * @returns { Promise<AttensiAPIResponse<ProductData>> } ProductData
     * @todo Write tests
     */
    Portal.prototype.getProductsToken = function (productToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/products/token/' + productToken)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/products/api_tokens/${productId}'
     * @async
     * @param  { number } productId
     * @returns { Promise<AttensiAPIResponse<PlatformApiToken[]>> } PlatformApiToken[]
     */
    Portal.prototype.getProductsApiToken = function (productId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get("/products/api_tokens/" + productId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/products/{product_id}/status'
     * @async
     * @param  { number } id
     * @returns { Promise<AttensiAPIResponse<ItemStatusData>> } ItemStatusData
     */
    Portal.prototype.getProductsStatus = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/products/' + id + '/status')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // TODO Test
    /**
     * Returns response from GET to '/products/{{product_id}}/redeem/itunes'
     * @async
     * @param  { number } productId
     * @returns { Promise<AttensiAPIResponse<TODO>> } TODO
     * @todo Write tests
     */
    Portal.prototype.getProductsRedeemItunes = function (productId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/products/' + productId + '/redeem/itunes')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/products/current'
     * @async
     * @returns { Promise<AttensiAPIResponse<ProductData>> } ProductData
     * @todo Write tests
     */
    Portal.prototype.getProductsCurrent = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/products/current')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns response from GET to '/leaderboards/high_score'
     * @async
     * @param  { LeaderboardsQuery } LeaderboardsQuery
     * @returns { Promise<AttensiAPIResponse<LeaderboardData>> } LeaderboardData
     */
    Portal.prototype.getLeaderboardsHighscore = function (leaderboardQuery) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        leaderboardQuery = leaderboardQuery ? leaderboardQuery : {};
                        return [4 /*yield*/, this.getWithQuery('/leaderboards/high_score', leaderboardQuery)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return Portal;
}(portalBase_1.PortalBase));
exports.Portal = Portal;
//# sourceMappingURL=portal.js.map